export const environment = {
    production: false,
    apiUrlEnv: 'https://rm.cmr.comprami.ro/api/v3',
    apiAuthUrlEnv: 'https://rm.cmr.comprami.ro/api/v3/token',
    taxeCmj: [161, 103, 105, 106, 113, 116, 117, 128, 133, 132, 102, 131],
    listaDocTipCertificat: [1, 2, 3, 4, 5, 6, 7, 8],
    // raportarea erorilor în Sentry, activă doar pe test și prod
    sentry: { dsn: 'https://c1d9c52cd8f243668fe82e2b79350dd0@o769226.ingest.sentry.io/6013490', environment: 'test' },
};
